import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-page-twelve',
  templateUrl: './home-page-twelve.component.html',
  styleUrls: ['./home-page-twelve.component.scss']
})
export class HomePageTwelveComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
